import { render, staticRenderFns } from "./LandingWishlistIT.vue?vue&type=template&id=16048648&scoped=true"
import script from "./LandingWishlistIT.vue?vue&type=script&lang=js"
export * from "./LandingWishlistIT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16048648",
  null
  
)

export default component.exports